import { FC } from 'react';
import { Link } from 'react-router-dom';
import IconArrowUp from '@shared/icons/IconArrowUp';
import IconArrowDown from '@shared/icons/IconArrowDown';

interface IStatisticsIndicatorProps {
  title: string;
  id?: number;
  value?: string | number | null;
  onClick?: () => void;
  selected?: boolean;
}

const UserIndicator: FC<IStatisticsIndicatorProps> = ({
  title,
  value,
  id,
  onClick,
  selected = false,
}) => {
  return (
    <div
      className={`p-[20px] border relative solid rounded-[16px] ${selected ? '' : 'border-opacity-30  border-[#959595]'} ${onClick ? 'cursor-pointer' : ''} w-full relative `}
      onClick={onClick}
    >
      {onClick ? (
        <>
          {selected ? (
            <>
              <div className="text-[white] absolute right-[15px] fill-[white] border border-opacity-20 border-solid rounded-[50%] w-[20px] h-[20px] flex items-center justify-center">
                <IconArrowDown />
              </div>
            </>
          ) : (
            <>
              <div className="text-[white] absolute right-[15px] fill-[white] opacity-30 border border-opacity-20 border-solid rounded-[50%] w-[20px] h-[20px] flex items-center justify-center">
                <IconArrowUp />
              </div>
            </>
          )}
        </>
      ) : null}
      <div className="text-[#777777]">{title}</div>
      <div className="text-[32px] gap-[5px] flex flex-wrap items-baseline">{value}</div>
    </div>
  );
};

export default UserIndicator;
